module.exports = __webpack_public_path__ + "static/media/trafficAnalysisLeads.cffeb785.svg";